import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type StatusVariant = 'pending' | 'partial' | 'paid' | 'active' | 'ended' | 'paused' | 'sent' | 'failed' | 'not_sent';

interface StatusBadgeProps {
  status: StatusVariant;
  className?: string;
}

const statusConfig: Record<StatusVariant, { label: string; className: string }> = {
  pending: {
    label: 'En attente',
    className: 'bg-warning/10 text-warning hover:bg-warning/20 border-warning/20',
  },
  partial: {
    label: 'Partiel',
    className: 'bg-warning/10 text-warning hover:bg-warning/20 border-warning/20',
  },
  paid: {
    label: 'Payé',
    className: 'bg-success/10 text-success hover:bg-success/20 border-success/20',
  },
  active: {
    label: 'Actif',
    className: 'bg-success/10 text-success hover:bg-success/20 border-success/20',
  },
  ended: {
    label: 'Terminé',
    className: 'bg-muted text-muted-foreground hover:bg-muted border-muted',
  },
  paused: {
    label: 'Suspendu',
    className: 'bg-warning/10 text-warning hover:bg-warning/20 border-warning/20',
  },
  sent: {
    label: 'Envoyé',
    className: 'bg-success/10 text-success hover:bg-success/20 border-success/20',
  },
  failed: {
    label: 'Échec',
    className: 'bg-destructive/10 text-destructive hover:bg-destructive/20 border-destructive/20',
  },
  not_sent: {
    label: 'Non envoyé',
    className: 'bg-muted text-muted-foreground hover:bg-muted border-muted',
  },
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status];
  
  return (
    <Badge
      variant="outline"
      className={cn('font-medium', config.className, className)}
    >
      {config.label}
    </Badge>
  );
}
